import {defineStore} from "pinia";

export const useMaintenanceStore = defineStore('maintenance.store', {
    state: () => {
        return {
            maintenance: false,
            expectedMaintenanceWindow: 5
        }
    },
    actions: {}
})